import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';

interface GetBulkRequestRolesParams {
  limit?: number;
  offset?: number;
  subjects?: (`MEMBER/${string}` | `GROUP/${string}`)[];
}
interface GetBulkRequestRolesResponse {
  roles: {
    id: string;
    workspaceId: string;
    bulkRequestId: string;
    subjectType: 'MEMBER' | 'GROUP';
    member?: {
      id: string;
      name: string;
      description: string;
      userId: string;
      userName: string;
      userEmail: string;
    };
    group?: { id: string; name: string; type: 'ALL_MEMBERS' | 'CUSTOM'; description: string };
    name: 'VIEWER' | 'EDITOR';
    createdAt: string;
    updatedAt: string;
  }[];
  count: number;
}
export function getBulkRequestRoles(
  workspaceId: string,
  bulkRequestId: string,
  params: GetBulkRequestRolesParams
): Promise<GetBulkRequestRolesResponse> {
  return requestApi<GetBulkRequestRolesResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/roles`),
    method: 'GET',
    credentials: true,
    params,
  }).then((response) => response.data);
}
